import React, { useState, useEffect } from 'react';
import { Typography, CardContent, CardMedia, Card, Box } from '@mui/material';
import { Link } from 'react-router-dom';
import { format, fromUnixTime } from 'date-fns';
import {es} from 'date-fns/locale';
import { db } from '../../../firebase/firebaseConfig';
import { collection, onSnapshot } from 'firebase/firestore';

const CardBlog = () => {
    const [blogs, setBlog] = useState([]);

    //formato de fecha
    const formatearFecha = (fecha) => {
      return format(fromUnixTime(fecha), "dd 'de' MMMM 'de' yyyy", {locale: es})
    }
  
    // Función para truncar el texto
    const truncateText = (text, maxLength = 100) => {
      return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
    }
  
    useEffect(() => {
      onSnapshot(collection(db, 'blogcalocho'),
          (snapshot) => {
              const arregloBlogs = snapshot.docs.map((docBlog) => {
                  return {...docBlog.data(), id: docBlog.id};
              })
  
              setBlog(arregloBlogs);
            },
            (error) => {
                console.log(error);
            }
        );
    }, []);  

    return (
        <Box sx={{
            width: { xs: '90%', sm: '80%', md: '100%' },  // Ancho adaptable
            display: 'grid', 
            gap: { xs: 1, sm: 1.5, md: 2 },
            gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', md: '0.5fr' },
        }}>
            {blogs.map((blog) => (
            <Card key={blog.id} sx={{
                width: '100%', 
                maxWidth: { xs: '100%', sm: '95%', md: '90%' },
                margin: 'auto',
                borderRadius: 2,
                boxShadow: 3,
                overflow: 'hidden',
            }}>
                <Link to={`/blog-detalle/${blog.id}`} style={{ textDecoration: 'none' }}>

                    <CardMedia 
                        component="img"
                        sx={{ 
                            width: '100%', 
                            height: { xs: 180, sm: 220, md: 250 },
                            objectFit: 'cover',
                        }}
                        image={blog.imagen}
                        alt={blog.titulo}>
                    </CardMedia>
                    <CardContent textAlign="center" sx={{ padding: { xs: 1, sm: 2, md: 3 } }}>
                        <Typography color="#0f0f0f" fontWeight="bold" sx={{ 
                            marginBottom: { xs: 1, sm: 2 },
                            fontSize: { xs: '1.4rem', sm: '1.6rem', md: '1.8rem' }, 
                            textAlign: 'center'
                        }}>Autor</Typography>
                        <Typography color="#0f0f0f" sx={{ 
                            marginBottom: { xs: 1, sm: 2 },
                            fontSize: { xs: '0.9rem', sm: '1rem', md: '1.1rem' },
                            textAlign: 'center'
                        }}>{blog.autor}</Typography>
                        <Typography color="#0f0f0f" fontWeight="bold" sx={{ 
                            marginBottom: { xs: 1, sm: 2 },
                            fontSize: { xs: '1.4rem', sm: '1.6rem', md: '1.8rem' }, 
                            textAlign: 'center'
                        }}>Título</Typography>
                        <Typography color="#0f0f0f" sx={{ 
                            marginBottom: { xs: 1, sm: 2 },
                            fontSize: { xs: '0.9rem', sm: '1rem', md: '1.1rem' },
                            textAlign: 'center'
                        }}>{blog.titulo}</Typography>
                        <Typography color="#0f0f0f" fontWeight="bold" sx={{ 
                            marginBottom: { xs: 1, sm: 2 },
                            fontSize: { xs: '1.4rem', sm: '1.6rem', md: '1.8rem' }, 
                            textAlign: 'center'
                        }}>Descripción</Typography>
                        <Typography color="#0f0f0f" sx={{ 
                            marginBottom: { xs: 1, sm: 2 },
                            fontSize: { xs: '0.9rem', sm: '1rem', md: '1.1rem' },
                            textAlign: 'center'
                        }}>
                            <span>{truncateText(blog.descripcion)}</span>
                        </Typography>
                        <Typography color="#0f0f0f" fontWeight="bold" sx={{ 
                            marginBottom: { xs: 1, sm: 2 },
                            fontSize: { xs: '1.4rem', sm: '1.6rem', md: '1.8rem' }, 
                            textAlign: 'center'
                        }}>Categoría</Typography>
                        <Typography color="#0f0f0f" sx={{ 
                            marginBottom: { xs: 1, sm: 2 },
                            fontSize: { xs: '0.9rem', sm: '1rem', md: '1.1rem' },
                            textAlign: 'center'
                        }}>{blog.categoria}</Typography>
                        <Typography color="#0f0f0f" fontWeight="bold" sx={{ 
                            marginBottom: { xs: 1, sm: 2 },
                            fontSize: { xs: '1.4rem', sm: '1.6rem', md: '1.8rem' }, 
                            textAlign: 'center'
                        }}>Se publicó el</Typography>
                        <Typography color="#0f0f0f" sx={{ 
                            marginBottom: { xs: 1, sm: 2 },
                            fontSize: { xs: '0.9rem', sm: '1rem', md: '1.1rem' },
                            textAlign: 'center'
                        }}>{formatearFecha(blog.fecha)}</Typography>
                        <Typography color="#0f0f0f" fontWeight="bold" sx={{ 
                            marginBottom: { xs: 1, sm: 2 },
                            fontSize: { xs: '1.4rem', sm: '1.6rem', md: '1.8rem' }, 
                            textAlign: 'center'
                        }}>Link</Typography>
                        <Typography variant="body2" color="#2b1ee1" sx={{ 
                            marginBottom: { xs: 1, sm: 2 },
                            fontSize: { xs: '0.9rem', sm: '1rem', md: '1.1rem' },
                            textAlign: 'center'
                        }}>{blog.urlarticulo}</Typography>
                    </CardContent>
                </Link>
            </Card>
            ))}
        </Box>
    );
}

export default CardBlog;